import type { GuestEnvironment } from "@afar-research/contracts";

/** Owner Stop cancels pending boots and failed runs while preserving the guest disk. */
export function guestEnvironmentCanStop(state: GuestEnvironment["state"]): boolean {
  return state === "creating" || state === "starting" || state === "running" || state === "failed";
}

export type GuestEnvironmentOperation =
  | "create"
  | "start"
  | "enroll"
  | "stop"
  | "delete"
  | "stop-create"
  | "create-stopped";

/** Pending boots may be superseded by durable Stop intent; other operations remain serialized. */
export function guestEnvironmentActionAdmission(
  action: "start" | "stop" | "delete",
  pending: GuestEnvironmentOperation | null,
) {
  if (
    pending === null ||
    pending === "create-stopped" ||
    action === "delete" ||
    (action === "stop" && (pending === "create" || pending === "start" || pending === "enroll"))
  )
    return { outcome: "allowed" as const };
  return { outcome: "refused" as const, reason: "operation-pending" as const };
}
